/**
 =========================================================
 * Material Dashboard 2 PRO React - v2.1.0
 =========================================================

 * Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
 * Copyright 2022 Creative Tim (https://www.creative-tim.com)

 Coded by www.creative-tim.com

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 */

import React, {useEffect, useState} from "react";
// react-router components
import {Navigate, Route, Routes, useLocation} from "react-router-dom";
// @mui material components
import {ThemeProvider} from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
// Material Dashboard 2 PRO React components
// Material Dashboard 2 PRO React examples
import Sidenav from "components/Sidenav";
// Material Dashboard 2 PRO React themes
import theme from "assets/theme";
// Material Dashboard 2 PRO React Dark Mode themes
import themeDark from "assets/theme-dark";
// RTL plugins
// Material Dashboard 2 PRO React routes
// Material Dashboard 2 PRO React contexts
import {setMiniSidenav, useMaterialUIController} from "context";
// Images
import brandWhite from "assets/images/logo.png";
import brandDark from "assets/images/logo.png";
import brandMini from "assets/images/logo_mini.png";
import {useDispatch, useSelector} from "react-redux";
import {signIn} from "./store/actions/auth";
import axios from "axios";
import {API_URL} from "./config";
import SignIn from "./layouts/authentication/sign-in";
import Loading from "./layouts/loading";
import {adminRoutes} from "./routes";
import RecoverPassword from "./layouts/authentication/recover-password";
import ResetPassword from "./layouts/authentication/reset-password";
import {SnackbarProvider} from "./context/SnackbarContext/SnackbarContext";
import NewScrape from "./layouts/scrape/new-scrape/NewScrape";
import ViewThread from "./layouts/threads/view/ViewThread";
import Threads from "./layouts/threads/list/Threads";
import NewUser from "./layouts/users/new-user/NewUser";
import EditUser from "./layouts/users/edit-user/EditUser";
import Users from "./layouts/users/view/Users";

export default function App() {
    const [controller, materialDispatch] = useMaterialUIController();

    const {
        miniSidenav,
        direction,
        layout,
        openConfigurator,
        sidenavColor,
        transparentSidenav,
        whiteSidenav,
        darkMode,
    } = controller;
    const [onMouseEnter, setOnMouseEnter] = useState(false);
    const {pathname} = useLocation();

    const dispatch = useDispatch();

    const authState = useSelector((state) => state.authReducer);

    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {

        const checkUser = async () => {
            setIsLoading(true);

            try {
                const response = await axios.get(`${API_URL}/user`);

                dispatch(signIn(response.data.user.id, response.data.user.name));

            } catch (error) {

            }

            setIsLoading(false);
        };

        checkUser();

    }, []);

    // Open sidenav when mouse enter on mini sidenav
    const handleOnMouseEnter = () => {
        if (miniSidenav && !onMouseEnter) {
            setMiniSidenav(materialDispatch, false);
            setOnMouseEnter(true);
        }
    };

    // Close sidenav when mouse leave mini sidenav
    const handleOnMouseLeave = () => {
        if (onMouseEnter) {
            setMiniSidenav(materialDispatch, true);
            setOnMouseEnter(false);
        }
    };

    // Setting page scroll to 0 when changing the route
    useEffect(() => {
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
    }, [pathname]);

    const getRoutes = (allRoutes) =>
        allRoutes.map((route) => {
            if (route.collapse) {
                return getRoutes(route.collapse);
            }

            if (route.route) {
                return <Route exact path={route.route} element={route.component} key={route.key}/>;
            }

            return null;
        });

    return <ThemeProvider theme={darkMode ? themeDark : theme}>
        <SnackbarProvider>
            <CssBaseline/>
            {
                isLoading ?
                    <Loading/> :
                    <>
                        {
                            authState.isLoggedIn ?
                                <>
                                    <Sidenav
                                        color={sidenavColor}
                                        brand={(transparentSidenav && !darkMode) || whiteSidenav ? brandDark : brandWhite}
                                        brandMini={brandMini}
                                        brandName=""
                                        routes={adminRoutes}
                                        onMouseEnter={handleOnMouseEnter}
                                        onMouseLeave={handleOnMouseLeave}
                                    />
                                    <Routes>
                                        <Route exact path="/usuarios" element={<Users/>} key="usuarios"/>
                                        <Route exact path="/usuarios/nuevo-usuario" element={<NewUser/>} key="nuevo-usuario"/>
                                        <Route exact path="/usuarios/:id/editar-usuario" element={<EditUser/>}
                                               key="editar-usuario"/>
                                        <Route exact path="/busqueda" element={<NewScrape/>}
                                               key="busqueda"/>
                                        <Route exact path="/hilos/" element={<Threads/>}
                                               key="hilos"/>
                                        <Route exact path="/hilos/:id" element={<ViewThread/>}
                                               key="hilo"/>
                                        <Route path="*" element={<Navigate to="/busqueda"/>}/>
                                    </Routes>
                                </> :
                                <Routes>
                                    <Route exact path="/autenticacion/iniciar" element={<SignIn/>}
                                           key="iniciar"/>
                                    <Route exact path="/autenticacion/recuperar" element={<RecoverPassword/>}
                                           key="recuperar"/>
                                    <Route exact path="/autenticacion/restablecer" element={<ResetPassword/>}
                                           key="restablecer"/>
                                    <Route path="*" element={<Navigate to="/autenticacion/iniciar"/>}/>
                                </Routes>
                        }
                    </>
            }
        </SnackbarProvider>
    </ThemeProvider>
}
